import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { AuthenticationService } from "../../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAbsenceType } from "app/auth/models/absences";

@Component({
  selector: "app-absences-type-form",
  templateUrl: "./absences-type-form.component.html",
  styleUrls: ["./absences-type-form.component.scss"],
})
export class AbsencesTypeFormComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public isEdit: boolean = false;
  public absence_id: number = 0;
  public showErrors: boolean = false;

  constructor(
    public _absencesService: AbsencesService,
    public _formBuilder: FormBuilder,
    private activated_route: ActivatedRoute,
    private router: Router,
    private _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
  ) {
    this.formGroup = this._formBuilder.group({
      name: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      code: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(5)]),
      type: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      require_note: new FormControl(""),
      require_file: new FormControl(""),
    });

    this.activated_route.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        this.isEdit = true;
        this.absence_id = Number(params.id);
      }
    });
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: this.isEdit ? "EDIT_TYPE_ABSENCE" : "ADD_TYPE_ABSENCE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.ABSENCES_TYPE",
            isLink: true,
            link: "/dashboard/absences-type-list",
          },
          {
            name: this.isEdit ? "EDIT" : "ADD",
            isLink: false,
          },
        ],
      },
    };

    if (this.isEdit) {
      const absenceType: IAbsenceType = await this._absencesService.getAbsenceType(this.absence_id);
      if (!absenceType) {
        await this.router.navigateByUrl("/dashboard/absence/edit");
      } else {
        this.formGroup.patchValue({
          name: absenceType.name,
          code: absenceType.code,
          type: absenceType.type,
          require_note: Boolean(absenceType.require_note),
          require_file: Boolean(absenceType.require_file),
        });
      }
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async create() {
    if (!this._authenticationService.hasCapability("create_absence_type")) {
      window.history.back();
      return false;
    }
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    let requireNoteValue = 0;
    let requireFileValue = 0;
    if (this.formGroup.value.require_note) {
      requireNoteValue = 1;
    }
    if (this.formGroup.value.require_file) {
      requireFileValue = 1;
    }
    let data: IAbsenceType = {
      name: this.formGroup.value.name,
      code: this.formGroup.value.code.toUpperCase(),
      type: this.formGroup.value.type,
      require_note: requireNoteValue,
      require_file: requireFileValue,
    };
    await this._absencesService
      .createType(data)
      .then(async () => {
        await this.router.navigateByUrl("/dashboard/absences-type-list");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_TYPE_ABSENCE" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_UPLOAD_TYPE_ABSENCE" }));
  }

  async update() {
    if (!this._authenticationService.hasCapability("edit_absence_type")) {
      window.history.back();
      return false;
    }
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    let requireNoteValue = 0;
    let requireFileValue = 0;
    if (this.formGroup.value.require_note) {
      requireNoteValue = 1;
    }
    if (this.formGroup.value.require_file) {
      requireFileValue = 1;
    }
    const data: IAbsenceType = {
      name: this.formGroup.value.name,
      code: this.formGroup.value.code.toUpperCase(),
      type: this.formGroup.value.type,
      require_note: requireNoteValue,
      require_file: requireFileValue,
    };
    await this._absencesService
      .updateType(this.absence_id, data)
      .then(async () => {
        await this.router.navigateByUrl("/dashboard/absences-type-list");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_TYPE_ABSENCE" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_EDIT_TYPE_ABSENCE" }));
  }
}
